import './main.less';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import SelectField from '../../shared/form-elements/select/field';
import InputField from '../../shared/form-elements/input';

const Form = props => {
	const submit = props.isEdit
		? props.handleSubmit(data => props.updateLocationPlan(data)
			.then(props.updateLocationsData)
			.then(props.setEditingCountryCode.bind(null, null))
		)
		: props.handleSubmit(data => props.submitNewLocationPlan(data).then(props.updateLocationsData));
	return (
		<tr>
			<td className="padding-3-15">
				<Field
					name='country_code'
					placeholder={props.intl('Geo')}
					component={SelectField}
					searchable={true}
					multi={false}
					options={props.loadGeosLookup}
				/>
			</td>
			<td className="padding-3-15">
				<Field name="free_leads" placeholder={props.intl('Free leads')} component={InputField} />
			</td>
			<td className="padding-3-15">
				<Field name="approves_plan" placeholder={props.intl('Approves plan')} component={InputField} />
			</td>
			<td className="flex-justify-bottom">
				<button className="ui-btn ui-btn-primary margin-top-15" onClick={submit} >
					{props.isEdit ? 'Update' : 'Add'}
				</button>
			</td>
		</tr>
	);
};

export default reduxForm({ form: 'addGeoRowForm' })(Form);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/locations-plan/add-geo-form.js